import type { CustomerDTO } from "@/models/dtos/customer-dto";
import { http } from "./http";
import type { CreateCustomerRequest } from "@/models/requests/create-customer-request";
import { notificationsService } from "./notifications-service";
import { authService } from "@/services/auth-service";

class CustomersService {
  async getCustomers() {
    const authHeader = await authService.getAuthHeader();
    return http
      .url("/customers")
      .auth(authHeader)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<CustomerDTO[]>();
  }

  async getCustomer(customerId: string | number): Promise<CustomerDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .url(`/customers/${customerId}`)
      .auth(authHeader)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<CustomerDTO>();
  }

  async getCustomerByCustomerNumber(
    customerNumber: string,
  ): Promise<CustomerDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .url(`/customers/customer-number/${customerNumber}`)
      .auth(authHeader)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<CustomerDTO>();
  }

  async createCustomer(request: CreateCustomerRequest): Promise<CustomerDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .url("/customers")
      .auth(authHeader)
      .post(request)
      .fetchError((err) => notificationsService.error(err))
      .json<CustomerDTO>();
  }
}

export const customersService = new CustomersService();
